export default {
  computed: {
    id: {
      get() {
        return this.$store.getters.getActiveWidget;
      },
    },
  },
  created() {
    this.$events.$off('set-active-widget-properties');

    this.$events.$on('set-active-widget-properties', (payload) => {
      switch (payload.component) {
        case 'AudioWidget':
          this.setNewTab(`audio${payload.id}`);
          break;
        case 'ClockWidget':
          this.setNewTab(`clock${payload.id}`);
          break;
        case 'ImageWidget':
          this.setNewTab(`image${payload.id}`);
          break;
        case 'PdfWidget':
          this.setNewTab(`pdf${payload.id}`);
          break;
        case 'TextWidget':
          this.setNewTab(`text-${payload.id}`);
          break;
        case 'VideoWidget':
          this.setNewTab(`video${payload.id}`);
          break;
        case 'WebpageWidget':
          this.setNewTab(`webpage${payload.id}`);
          break;
        case 'TickerWidget':
          this.setNewTab(`ticker${payload.id}`);
          break;
        case 'LibraryImageWidget':
          this.setNewTab(`library-image${payload.id}`);
          break;
        case 'LibraryAudioWidget':
          this.setNewTab(`library-audio${payload.id}`);
          break;
        case 'LibraryVideoWidget':
          this.setNewTab(`library-video${payload.id}`);
          break;
        case 'LibraryWebpageWidget':
          this.setNewTab(`library-webpage${payload.id}`);
          break;
        case 'LibraryPdfWidget':
          this.setNewTab(`library-pdf${payload.id}`);
          break;
        case 'YoutubeWidget':
          this.setNewTab(`youtube${payload.id}`);
          break;
        case 'TwitterWidget':
          this.setNewTab(`twitter${payload.id}`);
          break;
        case 'RssWidget':
          this.setNewTab(`rss${payload.id}`);
          break;
        case 'FacebookWidget':
          this.setNewTab(`facebook${payload.id}`);
          break;
        default:
          break;
      }
    });
  },
  methods: {
    setNewTab(newTabName) {
      if (
        this.tabs !== `tab-${newTabName}-general`
        && this.tabs !== `tab-${newTabName}-content`
        && this.tabs !== `tab-${newTabName}-states`
      ) {
        this.tabs = `tab-${newTabName}-general`;
      }
    },
    toggleDeformation() {
      if (this.deformation) {
        this.justifyContent = 'unset';
        this.alignItems = 'unset';
      } else {
        this.justifyContent = 'center';
        this.alignItems = 'center';
      }
    },
  },
};
